// extracted by mini-css-extract-plugin
export default {"container":"ConfirmSlider_container__nCIY4","inactive":"ConfirmSlider_inactive__bC9wC","label":"ConfirmSlider_label__WjX1Q","button":"ConfirmSlider_button__skqnO"};